import React, { Fragment } from 'react';
import { Form } from 'semantic-ui-react';
import AirlineAnswerDropdown from '../../dropdowns/AirlineAnswerDropdown';
import DateInput from '../../DateInput';

const Litigation = props => {
  const {
    onChange,
    values,
    claim
  } = props;

  if (!claim) {
    return null;
  }
  const disabledEdit = {
    airlineAmicableAnswer: !/^c[0-3]|^b/.test(claim.crmState),
    airlinePreLitigationAnswer: !/^c[0-3]/.test(claim.crmState),
    lawyerFormalNoticeDate:
      !claim.legalFormalNotice ||
      !/^c[4-8]|^c3_litigation_formal_notice_sent/.test(claim.crmState)
  };

  const airlineAnswerDropdown = (
    <AirlineAnswerDropdown
      disabled={disabledEdit.airlineAmicableAnswer}
      width={4}
      name="airlineAmicableAnswer"
      label="Airline Amicable Answer"
      value={values.airlineAmicableAnswer}
      onChange={onChange}
    />
  );

  if (claim.crmState.startsWith('b')) {
    return <Form.Group widths={4}>{airlineAnswerDropdown}</Form.Group>;
  }

  return claim.crmState.startsWith('c') ? (
    <Fragment>
      <Form.Group widths={4}>
        {airlineAnswerDropdown}
        <AirlineAnswerDropdown
          disabled={disabledEdit.airlinePreLitigationAnswer}
          width={4}
          name="airlinePreLitigationAnswer"
          label="Airline Pre Litigation Answer"
          placeholder="Airline Pre Litigation Answer"
          value={values.airlinePreLitigationAnswer}
          onChange={onChange}
        />
      </Form.Group>
      <Form.Group widths={4}>
        <DateInput
          disabled={disabledEdit.lawyerFormalNoticeDate}
          date={values.lawyerFormalNoticeDate}
          onChange={onChange}
          name={'lawyerFormalNoticeDate'}
          text={'Lawyer Formal Notice'}
          inputWidth={4}
        />
      </Form.Group>
    </Fragment>
  ) : null;
};

export default Litigation;



// WEBPACK FOOTER //
// ./src/component/ClaimForm/Form/AirlineAnswer.js